import React from "react";
import type { ILanguage, IProfile, IrMap } from "App/Modules/Models";
import { UserProfileIntro } from "./UserProfileIntro";
import { UserProfileSecurity } from "./UserProfileSecurity";

import "./_user-profile-details.scss";
import type { GetDataTransferStatus, SaveDataTransferStatus } from "./Types";

type UserProfileDetailsProps = {
    profile?: IProfile;
    languages: ILanguage[];
    locales: string[];
    timeZones: IrMap<string, string>;
    updateUser: (profile: IProfile) => void;
    dialogClosed: () => void;
    getLocalizationData: () => void;
    onFormReset: () => void;
    getProfileStatus: GetDataTransferStatus;
    saveProfileStatus: SaveDataTransferStatus;
    getLocalizationStatus: GetDataTransferStatus;
};

export const UserProfileDetails = (props: UserProfileDetailsProps) => {
    return (
        <div data-testid="user-profile-details" className="user-profile-details">
            <div className="user-profile-details__section">
                <UserProfileIntro
                    profile={props.profile}
                    languages={props.languages}
                    locales={props.locales}
                    timeZones={props.timeZones}
                    updateUser={props.updateUser}
                    dialogClosed={props.dialogClosed}
                    getLocalizationData={props.getLocalizationData}
                    onFormReset={props.onFormReset}
                    getProfileStatus={props.getProfileStatus}
                    saveProfileStatus={props.saveProfileStatus}
                    getLocalizationStatus={props.getLocalizationStatus}
                />
            </div>
            <div className="user-profile-details__section">
                <UserProfileSecurity
                    profile={props.profile}
                    updateUser={props.updateUser}
                    dialogClosed={props.dialogClosed}
                    onFormReset={props.onFormReset}
                    getProfileStatus={props.getProfileStatus}
                    saveProfileStatus={props.saveProfileStatus}
                />
            </div>
        </div>
    );
};
